import './Pagination.css'

/**
 * Базовый компонент пагинации по страницам.
 * Показывает диапазон (from–to из total) и номера страниц.
 *
 * @param {object} props
 * @param {number} props.page - текущая страница (0-based)
 * @param {number} props.total - общее кол-во записей
 * @param {number} props.limit - записей на страницу
 * @param {function} props.onPageChange - callback(page)
 * @param {boolean} [props.loading] - disabled во время загрузки
 * @param {function} props.t - функция перевода
 * @param {string} [props.rangeKey] - ключ для диапазона, default 'pagination.range'
 * @param {string} [props.pageKey] - ключ для aria-label страницы, default 'pagination.page'
 * @param {string} [props.className] - дополнительные классы для обёртки
 */
export default function Pagination({
  page,
  total,
  limit,
  onPageChange,
  loading = false,
  t,
  rangeKey = 'pagination.range',
  pageKey = 'pagination.page',
  className = '',
}) {
  const totalPages = total > 0 ? Math.ceil(total / limit) : 0
  const from = total > 0 ? page * limit + 1 : 0
  const to = total > 0 ? Math.min((page + 1) * limit, total) : 0

  const getPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i)
    if (page <= 3) {
      return [0, 1, 2, 3, 4, -1, totalPages - 1]
    }
    if (page >= totalPages - 4) {
      return [0, -1, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1]
    }
    return [0, -1, page - 1, page, page + 1, -1, totalPages - 1]
  }

  if (totalPages <= 0) return null

  return (
    <div className={`logs-proactive-pagination ${className}`.trim()}>
      <span className="logs-pagination-info">
        {t(rangeKey, { from, to, total })}
      </span>
      <div className="logs-pagination-pages">
        {getPageNumbers().map((p, i) =>
          p === -1 ? (
            <span key={`ellipsis-${i}`} className="logs-pagination-ellipsis">…</span>
          ) : (
            <button
              key={p}
              type="button"
              className={`logs-pagination-page ${p === page ? 'logs-pagination-page--active' : ''}`}
              onClick={() => onPageChange(p)}
              disabled={loading}
              aria-label={t(pageKey, { n: p + 1 })}
              aria-current={p === page ? 'page' : undefined}
            >
              {p + 1}
            </button>
          )
        )}
      </div>
    </div>
  )
}
